import React from "react"
import { AppContainerContext } from "./context"
import { AppContainer as AppContainerDisplay } from "./appContainer"
// import { DeployableContainer } from "../../../shared/Components/deployableContainer"

import '../../../assets/css/revised_css/index.css'
import { DiagnosticsContext } from "../contextProviders/diagnosticsContext"
import { NotificationContext } from "../contextProviders/notificationContext"
import { UserContext } from "../contextProviders/userContext"
// import { PhotoManagerContext } from "../contextProviders/photoManagerContext"
// import { AllReportsContext } from "../contextProviders/allReportsContext"
export function AppContainer() {


  return (
    <DiagnosticsContext>
      <NotificationContext>
        <UserContext>
          <AppContainerContext>
              <AppContainerDisplay />
          </AppContainerContext>
        </UserContext>
      </NotificationContext>
    </DiagnosticsContext>
  )
}